import script from "./funding-update-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./funding-update-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__